"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/partnerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type PartnerSectionPartnerTensItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-21.svg" | "/Templates/Doccure/img/company/company-22.svg" | "/Templates/Doccure/img/company/company-23.svg" | "/Templates/Doccure/img/company/company-24.svg" | "/Templates/Doccure/img/company/company-25.svg" */
    src: string;
    /** Detected variants: "partner-item-ten" */
    className?: string;
    /** Detected variants: "client logo" */
    alt?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeTenPartnerSectionGeneratedProps = {
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: PartnerSectionPartnerTensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Trusted & Recognized By" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div0Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    partnerSectionPartnerTens: PartnerSectionPartnerTensItem[];
    partnerSectionPartnerTensItemWrapper?: (item: PartnerSectionPartnerTensItem, content: ReactNode) => ReactNode;
    partnerSectionPartnerTensRenderer?: (defaultNode: ReactNode) => ReactNode;
    partnerSectionPartnerTensImageVisible?: boolean;
    partnerSectionPartnerTensImageRenderer?: (item: PartnerSectionPartnerTensItem, defaultNode: ReactNode) => ReactNode;
    partnerSectionPartnerTensImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: PartnerSectionPartnerTensItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeTenPartnerSectionGenerated: FC<HomeTenPartnerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H20H2Text = "Trusted & Recognized By",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Slider0SliderProps,
    sectionDiv0Div0ClassName,
    partnerSectionPartnerTens,
    partnerSectionPartnerTensItemWrapper,
    partnerSectionPartnerTensRenderer,
    partnerSectionPartnerTensImageVisible,
    partnerSectionPartnerTensImageRenderer,
    partnerSectionPartnerTensImageProps,
}) => {
    return (
        <section className="partner-section-ten">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-10 mx-auto">
                        <div className="section-header">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="sub-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                        <Slider {...settings} className="partner-slider-ten" {...(sectionDiv0Div0Div0Slider0SliderProps ?? {})}>
                            {renderCollectionNode(
                                partnerSectionPartnerTens,
                                (item: PartnerSectionPartnerTensItem) => (
                                    <div className={item.className ?? "partner-item-ten"} key={item.key}>
                                        {renderItemNode(partnerSectionPartnerTensImageVisible, partnerSectionPartnerTensImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "client logo"} {...(typeof partnerSectionPartnerTensImageProps === "function" ? partnerSectionPartnerTensImageProps(item) : (partnerSectionPartnerTensImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                ),
                                partnerSectionPartnerTensItemWrapper,
                                partnerSectionPartnerTensRenderer
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeTenPartnerSectionGenerated;
